<template>
    <f7-page id="account-fx-alert" name="account-fx-alert" class="bg-color-white" @page:afterin="afterin">
        <f7-navbar class="view-mobile no-border">
            <f7-nav-left class="back-button">
                <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
            </f7-nav-left>
            <f7-nav-right></f7-nav-right>
        </f7-navbar>
        <div class="block">
            <f7-card
                id     = "errorCard"
                class  = "alert mb-20"
                v-show = "alertCard.show"
                :class = "alertCard.alertClass"
                >
                  <div v-html="alertCard.title" slot="header"></div>
                  <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
            </f7-card>

            <div class="fw-bold fs-24 mb-md">{{ $t('fx-alert-create-title') }}</div>
            <p class="text-color-gray m-0 fs-14">{{ $t('fx-alert-description') }}</p>

            <div class="d-flex-center justify-content-center fw-medium fs-14 mt-3 pt-1 color-gray6">
                <div class="py-3 me-3 flex-1 bg-color-green text-color-white d-flex-center justify-content-center segmented">
                    <img :src="getCircleSmallFlagImg(hostCountry.id)" class="mr-sm" />
                    <span>{{ hostCountry.currencyCode }}</span>
                </div>
                <img :src="require('@/assets/img/icon/icon-arrow-right.svg')" width="30" />
                <f7-link popover-open=".popover-home-currency" class="popover-fx-currency py-3 ms-3 flex-1 bg-color-green text-color-white d-flex-center font-no-decoration segmented" slot="media">
                    <div class="d-flex-center justify-content-between w-80">
                        <div class="d-flex-center">
                            <img :src="getCircleSmallFlagImg(homeCountry.id)" class="mr-sm" />
                            <span>{{ homeCountry.currencyCode }}</span>
                        </div>
                        <i class="f7-icons">chevron_down</i>
                    </div>
                </f7-link>
                <f7-popover class="popover-home-currency popover-fx-currency" :backdrop="true">
                    <f7-list>
                        <f7-list-item popover-close link="#" v-for="country in fxRateCountryList" :key="country.id" :selected="homeCountry.id == country.id" @click="eventChangeHomeCountry(country)">
                            <img :src="getCircleSmallFlagImg(country.id)" class="mr-sm" />
                            {{ country.currencyCode }}
                        </f7-list-item>
                    </f7-list>
                </f7-popover>
            </div>

            <p class="text-center mt-lg fs-14 mb-sm">{{ $t('fx-alert-current-rate') }}</p>
            <p class="text-center mt-0 fs-16 fw-medium mb-lg">{{ hostAmount }} {{ hostCountry.currencyCode }} = {{ activeRate.bidRateDisplay }} {{ homeCountry.currencyCode }}</p>

            <p class="mt-0 mb-1 fs-14">Notify me when {{ hostAmount }} {{ hostCountry.currencyCode }} is above</p>
            <div class="d-flex-center color-gray6 bg-color-primary px-3 fs-14">
                <span class="fw-medium mr-md">{{ homeCountry.currencyCode }}</span>
                <f7-input
                    input-id      ="homeAmount"
                    name          ="homeAmount"
                    type          ="text"
                    class         ="w-100 amountField"
                    autocomplete  ="off"
                    pattern       ="[0-9]*"
                    inputmode     ="decimal"
                    placeholder   ="0.00"
                    :value        ="homeObj.amount == 0 ? '' : homeObj.amount"
                    @blur         ="onAmountBlur($event.target.value);"
                    @focus        ="onAmountFocus();"
                    @keypress.native  ="$event.keyCode == 13 || $event.key.toUpperCase() === 'ENTER' ? (homeObj.amount = $event.target.value, $event.target.blur()) : ''"
                    outline
                    @keydown.native   ="preventInvalidNumericInput($event)"
                ></f7-input>
            </div>

            <f7-button class="mb-sm mt-xl" large fill @click="createFxAlert" :disabled="homeObj.amountReal <= 0">
                {{$t('fx-alert-btn-create')}}
            </f7-button>
        </div>
    </f7-page>
</template>

<style>
.amountField.input-outline input {
    background-color: var(--f7-theme-color);
    border-color: var(--f7-theme-color);
    text-align: right;
    padding: 0;
}
.flex-1 {
    flex: 1;
    max-width: 132px;
}
</style>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { fxRateHelper as FX }  from '@/plugins/helper'

    export default {
        mounted (){
            this.getDeliveryMethodList(this.homeCountry.id, false);
            this.getFxRate();
        },
        data() {
            return {
                activeRate              : { bidRate : 0, bidRateDisplay : "0.00" },
                alertCard               : { show : false, title : "error", content : "", alertClass:"alert-danger"},
                bankTypeId              : 1,
                deliveryMethodId        : 0,
                hostAmount              : 1,
                fxRateObject            : { fxRateList : {} },
                fxRateCountryList       : [],
                homeObj                 : { amount : "", amountReal : 0 },
                hostCountry             : { id: 189, currencyCode: "SGD", name: "Singapore" },
                homeCountry             : { id: 99, currencyCode: "IDR", name: "Indonesia" }
            }
        },
        methods: {
            ...mapActions('auth', ['login']),
            afterin(){
                window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
            },
            getFxRate(){
                const self = this;
                self.showPreloader();

                const fxRateListPromise    = this.$api.exchangeRate.getFXRateList(-1, 0, this.$store.state.customer.customerId)
                const fxCountryListPromise = this.$api.exchangeRate.getFxCountryList()

                Promise.all([fxRateListPromise, fxCountryListPromise]).then((response)=>{
                    const fxRateList    = response[0]
                    const fxCountryList = response[1]

                    this.$_.each(fxRateList, (fxRate) => {
                        if(fxRate.currency == self.homeCurrency && fxRate.deliveryMethodId == self.deliveryMethodId) {
                            self.bankTypeId = fxRate.bankTypeId;
                        }
                    })

                    self.fxRateObject.fxRateList = FX.buildRateList(fxRateList)
                    self.fxRateCountryList       = FX.rearrageCountryList(fxCountryList, fxRateList)

                    for (let i = 0; i < self.fxRateCountryList.length; i++ ) {
                        if (self.fxRateCountryList[i].id == self.homeCountry.id) {
                            self.homeCountry = self.fxRateCountryList[i];
                            break
                        }
                    }

                    self.activeRate = self.populateActiveRate()
                    self.hidePreloader()
                })
            },
            onAmountBlur(val) {
                if(!this.$f7.device.ios) {
                    this.$$('#homeAmount').attr('type', 'text')
                }
                this.homeObj.amountReal = FX.formatDisplayRate(parseFloat(val), {countryId: this.activeRate.currencyId, isDisplay: true}).replace(',', '') || 0;
                this.homeObj.amount = this.homeObj.amountReal == 0 ? "" : FX.formatDisplayRate(this.homeObj.amountReal, {countryId: this.activeRate.currencyId, isDisplay: true})

                this.alertCard.show = false;
            },
            onAmountFocus(){
                this.homeObj.amount = this.homeObj.amountReal == 0 ? "" : this.homeObj.amountReal;
                if(!this.$f7.device.ios) {
                    this.$$('#homeAmount').attr('type', 'number');
                }
            },
            eventChangeHomeCountry(country) {
                this.showPreloader();
                this.homeCountry = country;
                this.getDeliveryMethodList(country.id, true)
            },
            populateActiveRate(){
                let list = this.fxRateObject.fxRateList || {}
                let homeCountryDetails = {
                    countryId : this.homeCountry.id,
                    dmId      : this.deliveryMethodId,
                    bankTypeId: (this.bankTypeId > 0) ? this.bankTypeId : 1
                }

                let newList = FX.getFxRateFromList(list, {countryId: this.hostCountry.id}, homeCountryDetails)
                if ( newList !== undefined ) { newList.bidRateDisplay = FX.formatDisplayRate(newList.bidRate, {countryId: this.homeCountry.id, isDisplay: true}) }

                return newList
            },
            getDeliveryMethodList(countryId, executeChangeFxParam){
                let self = this;
                const fxDeliveryMethodListPromise = self.$api.exchangeRate.getDeliveryMethodList(countryId)
                fxDeliveryMethodListPromise.then((dmList) => {
                    for (let key in dmList ){
                        if((countryId == 95 && key == 3) || (countryId == 236 && key == 1) || (countryId == 208 && key == 3)) {
                            continue
                        } else {
                            self.deliveryMethodId = key;
                            break;
                        }
                    }

                    if(executeChangeFxParam) {
                        self.activeRate = self.populateActiveRate()
                        self.hidePreloader();
                    }
                })
            },
            async createFxAlert() {
                this.showPreloader();
                try {

                    //if(this.activeRate.bidRate >= this.homeObj.amountReal){
                    //  this.showErrorCard(this.$t('fx-alert-target-rate-error'));
                    //  this.hidePreloader();
                    //  return false;
                    //}

                    const result = await this.$api.exchangeRate.createFXRateAlert(this.hostCountry.id, this.homeCountry.id, this.homeObj.amountReal);
                    this.hidePreloader();
                    if(result === undefined || result.length <= 0) {
                        this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                        return false;
                    }else if(result.status == "WN00322"){
                        this.$f7.dialog.alert(this.$t('fx-alert-duplicate-error'));
                        return false;
                    }

                    this.backButton();
                } catch(e){
                    this.hidePreloader();
                    if(e.message.toLowerCase().includes("undefined")) {
                        this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                    } else {
                        this.$f7.dialog.alert(e.message);
                    }
                }
            },
            showErrorCard(errorMessage) {
                this.alertCard.title      = errorMessage
                this.alertCard.alertClass = 'alert-danger'
                this.alertCard.show       = true
            },
            backButton() {
                this.$f7router.back({ transition: 'f7-push' });
            }
        },
        computed: {
            ...mapGetters('auth', [
                'authenticating',
                'authenticationError',
                'authenticationErrorCode',
                'authenticationSuccess'
            ])
        }
    }
</script>